<template>
  <div>
    <div v-if="sheetIsActive" class="max-w-3xl bg-white rounded-md shadow">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <search-select-input
            id="select-street-input"
            ref="streetInput"
            v-model="form.street_id"
            :options="streets"
            :error="form.errors.street_id"
            :label="$t('dashboard.form.street_label')"
            value="id"
            text="street_name"
            :placeholder="$t('dashboard.form.street_placeholder')"
            class="pb-8 pr-6 w-full lg:w-1/2"
          />

          <search-select-input
            id="select-house-input"
            ref="houseInput"
            v-model="form.house_id"
            :options="selectedStreet.houses"
            :error="form.errors.house_id"
            value="id"
            text="house_number"
            :label="$t('dashboard.form.house_label')"
            :placeholder="$t('dashboard.form.house_placeholder')"
            class="pb-8 pr-6 w-full lg:w-1/2"
          />

          <div class="pb-8 pr-6 w-full lg:w-1/1" v-if="selectedHouse && selectedHouse.id">
            <div class="flex-col w-full py-4 mx-auto mt-3 bg-sun-200 border-b-2 border-r-2 border-gray-200 sm:px-4 sm:py-4 md:px-4 sm:rounded-lg sm:shadow-sm md:w-2/3">
              <div class="flex flex-row md-10">
                <div class="flex-col mt-1">
                  <div class="flex items-center flex-1 px-4 font-bold leading-tight">{{ $t('dashboard.form.main_comment') }}</div>
                  <div class="flex-1 px-2 ml-2 text-sm font-medium leading-loose text-gray-600">
                    {{ selectedHouse.comment }}
                  </div>
                </div>
              </div>
            </div>

            <template v-if="selectedHouse.comments_for_user && selectedHouse.comments_for_user.length">
              <div
                v-for="comment in selectedHouse.comments_for_user"
                :key="comment.id"
                class="flex-col w-full py-4 mx-auto mt-3 bg-gray-100 border-b-2 border-r-2 border-gray-200 sm:px-4 sm:py-4 md:px-4 sm:rounded-lg sm:shadow-sm md:w-2/3"
              >
                <div class="flex flex-row md-10">
                  <div class="flex-col mt-1">
                    <div class="flex items-center flex-1 px-4 font-bold leading-tight">{{ authUser.id == comment.user_id ? 'You' : comment.user_name }}
                      <span class="ml-2 text-xs font-normal text-gray-500">{{ formatDate(comment.created_at) }}</span>
                    </div>
                    <div class="flex-1 px-2 ml-2 text-sm font-medium leading-loose text-gray-600">
                      {{ comment.comment }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <textarea-input
            v-model="form.comment"
            :error="form.errors.comment"
            :label="$t('dashboard.form.your_comment')"
            class="pb-8 pr-6 w-full lg:w-1/1"
          />
        </div>

        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ $t('dashboard.form.submit') }}</loading-button>
        </div>
      </form>
    </div>
    <span v-else>
      {{ $t('dashboard.form.form_disabled', {formName: authUser?.sheet?.name ?? '' }) }}
    </span>
  </div>
</template>

<script>
// Components
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import SearchSelectInput from '@/Shared/SearchSelectInput'

// Plugins
import {find} from 'lodash'
import Date from '@/Mixins/Date'

export default {
  components: {
    LoadingButton,
    TextareaInput,
    SearchSelectInput,
  },
  mixins: [Date],
  props: {
    streets: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        street_id: null,
        house_id: null,
        comment: null,
      }),
    }
  },
  computed: {
    selectedStreet() {
      if (this.form.street_id) {
        return find(this.streets, {id: this.form.street_id})
      }

      return {houses: []}
    },
    selectedHouse() {
      if (
        this.form.house_id &&
        this.selectedStreet.houses.length
      ) {
        return find(this.selectedStreet.houses, {id: this.form.house_id})
      }

      return null
    },
  },
  methods: {
    store() {
      this.form.post(this.route('comments.store'), {
        onSuccess: () => {
          this.form.reset()
          this.$refs.streetInput.refreshSelected(this.form.street_id)
          this.$refs.houseInput.refreshSelected(this.form.house_id)
        },
      })
    },
  },
}
</script>
